<template>
<div class="panel">
    <div  :id="config.name">
        <Row type="flex" justify="start" :gutter="4" style="margin-bottom: 5px;" v-show="!myConfig.readOnly">
        <Col>
            <Button icon="ios-add" size="small" @click="addRow">新增</Button>
        </Col>
        <Col>
            <Button icon="ios-remove" size="small" @click="delRow">删除</Button>
        </Col>
        </Row>
        <Table ref="table"  :loading="loading" :size="myConfig.tableSize"  :stripe="myConfig.showStripe" :border="myConfig.showBorder" :height="currentHeight":show-header="myConfig.showHeader" :columns="tableColumns"  :data="data" ></Table>
        <Modal v-if="!editRowFlag"  v-model="showEditRowForm"  width="90%" title="编辑" @on-ok="editRow">
            <div>
            <ExpandRow ref="rowForm"  :config="myConfig" :dictData="dictData"/>
            </div>
        </Modal>
    </div>
</div>
</template>
<script>
import Base from './basegrid.vue';
export default {
    name: 'editgrid',
    extends: Base,
    data () {
        return {
            myConfig:{
                resources:'',
                method:'',
                response:'',
                searchParam:null,
                readOnly:false,
                showIndex:true,
                showCheckBox:true,
                multiSelect:true,
                addRowBefore:'',
                name:'',
                editItemMaxNum:8,
                lineNum:4,
                labelWidth:100,
                tdHeight: 30
            },
            showEditRowForm:false,
            defaultRow:{},
            editItemNum:0,
            rowAction:[{
                iconcls: 'row',
                name: 'editRowForm',
                text: '编辑'
            }]
        };
    },
    methods: {
        customInit() {
            
            if (this.myConfig.items && this.myConfig.items.length > 0) {
                this.myConfig.items.forEach(el => {
                    if (el.defaultValue !== undefined) {
                        this.defaultRow[el.name] = el.defaultValue;
                    } else {
                        this.defaultRow[el.name] = '';
                    }
                    el.editing = true;
                    if (el.visible !== false) {
                        this.editItemNum++;
                    }
                });
            }
            if (this.editItemNum > Number(this.myConfig.editItemMaxNum)) {
                //启动行表单编辑模式
                this.showRowAction = true;
                this.myToolConfig.items = this.$Method.copy(this.rowAction);
                this.editRowFlag = false;
            } else {
                this.toolConfig.items =[];
                this.showRowAction = false;
                this.editRowFlag = true;
            }
        },
        conditionAction(temp) {
            let data = [];
            switch (temp.action) {
                case 'condition_search' :
                    if (temp.para) {
                        this.conditionSearchParam = this.$Method.copy(temp.para);
                    }
                    this.refurbish();
                    break;
                case 'condition_clear' :
                    this.conditionSearchParam = {};
                    break;
                case 'condition_ok' :
                    if (this.myConfig.multiSelect) {
                        data = this.$refs.table.getSelection();
                    } else {
                        if (this.singleData.currentRow) {
                            data.push(this.singleData.currentRow);
                        }
                    }
                    if (data.length === 0) {
                        this.alert('请选择');
                    } else {
                        temp.action = 'viewgrid_ok';
                        temp.rows = data;
                        this.$emit('viewGridAction',temp);
                    }
                    break;
                case 'condition_cancel' :
                    temp.action = 'viewgrid_cancel';
                    this.$emit('viewGridAction',temp);
                    break;
            }
        },
        setColumnRendel(column) {
            if (this.myConfig.readOnly === false && column.readOnly !== true) {
                column.editing = true;
            } else {
                column.editing = false;
            }
        },
        getSelection() {
            return  this.$refs.table.getSelection();
        },
        addRow () {
            let row = null;
            if (this.myConfig.addRowBefore) {
                let obj = {};
                obj.name = this.myConfig.name;
                obj.grid = this.$refs.table;
                row = this.myConfig.addRowBefore(obj);
                if (!row) {
                    return;
                }
            }

            if (!row) {
                row = {};
            }
            
            for(let temp in this.defaultRow) {
                row[temp] = this.defaultRow[temp];
            }

            row.flag = 'I';

            this.data.push(row);
        },
        setPro (obj) {
            if (obj) {
                this.myConfig = Object.assign({}, this.myConfig, obj);
            }
        },
        setReadOnly(value) {
            let obj = {};
            obj.readOnly = value;
            if (obj.readOnly) {
                obj.showCheckBox = false;
            } else {
                obj.showCheckBox = true;
            }
            this.setPro(obj);
        },
        delRow() {
            let row = null;
            if (this.myConfig.delRowBefore) {
                let obj = {};
                obj.name = this.myConfig.name;
                obj.grid = this.$refs.table;
                row = this.myConfig.delRowBefore(obj);
                if (!row) {
                    return;
                }
            }
            let selectionRows = this.getSelectionIndex();
            const length = selectionRows.length ;
            for (let i = 0; i <  length; i++) {
                this.remove(selectionRows[i]);
            }
        },
        getData() {
            return this.data;
        },
        updateRow(index,obj) {
            if (this.data[index].flag === undefined) {
                obj.flag = 'U';
            }
            obj = Object.assign({},this.data[index],obj);
            this.data.splice(index,1,obj);
        },
        initRowForm(obj) {
            this.showEditRowForm = true;
            this.$refs.rowForm.setData(obj.rowinfo.row);
        },
        customInitOperColumn(action) {
            if (this.myConfig.readOnly !== true) {
                this.columns.push(action);
            } 
        },
        editRow() {
            let row = this.$refs.rowForm.getData();
            if (row._index !== undefined) {
                this.updateRow(row._index,row);
            }
        },
        getChangeData() {
            let changeData = [];
            if (this.data.length > 0) {
                this.data.forEach(el => {
                    if (el.flag !== undefined) {
                        changeData.push(el);
                    }
                });
            }
            return changeData.concat(this.delData);
        }
    }
};
</script>
<style>
 .panel .ivu-table {
     font-size: 12px;
 }
 .ivu-table {
     font-size: 12px;
 }
</style>



// WEBPACK FOOTER //
// src/components/grid/ocmeditgrid.vue